import { gql } from "@apollo/client";

export const GENERATE_COUPON = gql`
  mutation GenerateAndStoreCoupon($input: CreateCouponInput!) {
    generateAndStoreCoupon(input: $input) {
      error {
            message
            code
            field
        }
        data {
            message
            code
            count
            couponDetails {
                package_name
                id
                code
                membership_durationId
                receiver_detail
                created_at
            }
        }
    }
  }
`;

export const REDEEM_COUPON = gql`
 mutation RedeemCoupon($coupon_code:String!, $user_id:UUID!) {
    redeemCoupon(coupon_code: $coupon_code, user_id: $user_id) {
         data {
            user_membership {
                membership_end_date
                user_id
                membership_duration_id
                id
                membership_join_date
                membership_duration {
                    number_of_days
                    duration_type
                    id
                    price
                    description
                    package_id
                    package {
                        description
                        package_type
                        created_at
                        updated_at
                        id
                        name
                    }
                }
            }
        }
        error {
            field
            message
            code
        }
    }
}

`;
